import firedux from '../firedux'
import {dispatch} from '../store'

import signInUser from '../actions/sign_in_user'
import signInGuest from '../actions/sign_in_guest'

export default (cb) => {
  firedux.ref.onAuth((authData) => {
    if (authData) {
      dispatch(signInUser(authData, null))
    }

    cb(authData)
  })
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/auth.js
 **/